import { CANCELLABLE_ORDER_STATUSES, UserRole } from '@lombok/shared';
import type { OrderStatus, UserRole as UserRoleType } from '@lombok/shared';

/** Roles that act on the operational pipeline (submit/cancel) beyond the owner. */
export const INTERNAL_ACTOR_ROLES: readonly UserRoleType[] = [
  UserRole.SUPER_ADMIN,
  UserRole.ADMIN,
  UserRole.SALES_MANAGER,
  UserRole.SALES_REP,
];

/**
 * Whether to offer "Cancelar pedido": only in a status the API still lets you cancel from, and
 * only to the roles that cancel today (internal staff and the customer who owns the order).
 * A UX gate; the API re-checks both.
 */
export function canCancelOrder(role: UserRoleType, status: OrderStatus): boolean {
  const mayCancel = INTERNAL_ACTOR_ROLES.includes(role) || role === UserRole.CUSTOMER_USER;
  return mayCancel && CANCELLABLE_ORDER_STATUSES.includes(status);
}
